import React, { useState } from 'react';
import { FiSend } from 'react-icons/fi';

const ACK_REPLIES = [
  'Acknowledged — adding that to my queue.',
  'Understood. I will factor that into the next run.',
  'Got it. Logging this instruction to memory.'
];

// "Talk to Agent" entry point (T6.4). Local-only conversation until the
// chat API exists; the agent acks with a canned reply after a short delay.
function AgentChatPanel({ agent }) {
  const [isOpen, setIsOpen] = useState(false);
  const [draft, setDraft] = useState('');
  const [messages, setMessages] = useState([]);

  const sendMessage = (event) => {
    event.preventDefault();
    const text = draft.trim();

    if (!text) {
      return;
    }

    const userMessage = { id: `msg-${Date.now()}`, author: 'you', text };
    setMessages((previous) => [...previous, userMessage]);
    setDraft('');

    setTimeout(() => {
      setMessages((previous) => [
        ...previous,
        {
          id: `msg-${Date.now()}`,
          author: agent.name,
          text: ACK_REPLIES[previous.length % ACK_REPLIES.length]
        }
      ]);
    }, 600);
  };

  return (
    <section className={`chat-panel ${isOpen ? 'is-open' : ''}`}>
      <button
        aria-expanded={isOpen}
        className="chat-panel-toggle"
        onClick={() => setIsOpen((previous) => !previous)}
        type="button"
      >
        Talk to {agent.name}
      </button>
      {isOpen && (
        <div className="chat-panel-body">
          <div className="chat-messages">
            {messages.length === 0 && (
              <p className="tab-empty">No messages yet — say hello.</p>
            )}
            {messages.map((message) => (
              <p className={`chat-message from-${message.author === 'you' ? 'user' : 'agent'}`} key={message.id}>
                <strong>{message.author}</strong>
                <span>{message.text}</span>
              </p>
            ))}
          </div>
          <form className="chat-composer" onSubmit={sendMessage}>
            <input
              aria-label={`Message ${agent.name}`}
              onChange={(event) => setDraft(event.target.value)}
              placeholder={`Message ${agent.name}…`}
              type="text"
              value={draft}
            />
            <button aria-label="Send message" className="primary-button" type="submit">
              <FiSend />
            </button>
          </form>
        </div>
      )}
    </section>
  );
}

export default AgentChatPanel;
